import { merge } from 'lodash'
import { Address, CustomerAddress, FormField, CheckoutStoreSelector } from '@bigcommerce/checkout-sdk'

import { isValidCustomerAddress } from '../../address'
import { mapCustomFormFieldsFromFormValues } from '../../formFields';

import { State, AddressInfo, Country } from '../request/apis'
import { B3CompanyStatus, B3Role } from './constants'
import storage from './storage'
import { paymentMethodsFixedMap } from '../config'
import b3Address from '../shipping'
import { cloneDeep } from 'lodash'

export const detectB3User = () => {
  const { SALESREP, ADMIN, SENIOR } = B3Role

  const { APPROVED } = B3CompanyStatus

  const roleId = storage.B3RoleId.getValue()
  const companyStatus = storage.B3CompanyStatus.getValue()

  return (
    roleId === SALESREP ||
    ([ADMIN, SENIOR].includes(roleId) && companyStatus === APPROVED)
  )
}

export const parseAddress = (
  source: AddressInfo & {
    companyName: string
    type: string
    customFields: any
    countryCode?: string
  },
) => {

  const isStringState = typeof source.state === 'string'
  const isStringCountry = typeof source.country === 'string'

  const label = source.label ? `${source.label}/` : ''
  const id = source.addressId ? +source.addressId : ''

  return merge({}, {
    ...source,
    id,
    firstName: source.firstName ?? '',
    lastName: source.lastName ?? '',
    company: `${label}${source.companyName}`,
    address1: source.addressLine1 ?? '',
    address2: source.addressLine2 ?? '',
    city: source.city ?? '',
    stateOrProvince: isStringState
      ? source.state as string
      : (source.state as State)?.stateName,
    stateOrProvinceCode: isStringState
      ? ''
      : (source.state as State)?.stateCode,
    countryCode: isStringCountry ? '' : (source.country as Country).countryCode,
    postalCode: source.zipCode ?? '',
    phone: source.phoneNumber ?? '',
    type: source.type ?? '',
    customFields: source?.customFields ?? [],
    country: isStringCountry ? source.country as string : (source.country as Country).countryName,
  })
}


export const addressesFilterHandler = (q: string, addresses: CustomerAddress[]) => {
  return addresses.filter(address => JSON
    .stringify(address)
    .trim()
    .toLocaleLowerCase()
    .includes(
      q
      .trim()
      .toLocaleLowerCase()
    )
  )
}

export const formatAddresses = (companyName: any, addresses: {
  [id: string]: AddressInfo,
}, data: CheckoutStoreSelector) => Object.entries(addresses).map(([addressId, address]) => {
  const customerAccountFields = data
    .getShippingAddressFields((address.country as Country).countryCode)
    .filter(field => field.custom)
    .reduce((result, { id, default: defaultValue, fieldType }) => {
      (result as any)[id] = B3SetField(defaultValue, fieldType)
      return result
    }, {})

  return parseAddress({
    ...address,
    addressId,
    companyName,
    type: "residential",
    customFields: mapCustomFormFieldsFromFormValues(customerAccountFields),
  })
})

export const validateAddress = (address: Address | undefined, addresses: Address[], formFields: FormField[]) => {
  if (!address) return false
  const isNullStateOrProvince = address.stateOrProvinceCode && !address.stateOrProvince
  if ((address as any)?.b2bCustomFields) delete (address as any).b2bCustomFields
  const comparedKeys = Object.keys(b3Address.convertShippingAddress(address))
  if (comparedKeys.indexOf('shouldSaveAddress') !== -1) comparedKeys.splice(comparedKeys.indexOf('shouldSaveAddress'), 1)
  let comparedAddresses = addresses.map(address =>
      comparedKeys.reduce((result, key) => {
          if (isNullStateOrProvince && key === 'stateOrProvince') result.stateOrProvince = ''
          else result[key] = (address as any)[key] || ''
          return result
      }, {} as any)
  )

  return isValidCustomerAddress(
      address as Address,
      comparedAddresses as CustomerAddress[],
      formFields
  )
}

export const paymentFilter = (methods: any[], b3Methods: { code: string }[]) => {

  let b3MethodCodes: any
  // ip checkout
  if (localStorage.getItem('IPCheckout') === '1') {
    methods = methods.filter(({
      type
    }) => (type !== 'PAYMENT_TYPE_OFFLINE'))

    b3MethodCodes = b3Methods
  } else {
    b3MethodCodes = b3Methods.map((b3Method: { code: string }) => b3Method.code)
  }

  return methods.filter(({
    id,
    gateway,
  }: { id: any; gateway: any }) => 
    b3MethodCodes.includes(id) 
    || b3MethodCodes.includes(gateway) 
    || b3MethodCodes.includes(paymentMethodsFixedMap[id])
  )
}

export const B3SetField  = (value: any , type: any) =>  {
  if  (value) return  value
  if (type === 'checkbox') return []
  return ''
}

export const modifiedCustomFields = (basicAddress: any) => {
  if (!basicAddress) return basicAddress
  let addressInfo: any  =  {}
  let basicAddressInfo =  cloneDeep(basicAddress)
  if (basicAddressInfo?.customFields && basicAddressInfo?.customFields.length)  {
    basicAddressInfo?.customFields.forEach((item: any) => {
        addressInfo[item.fieldId] = item.fieldValue || ''
      })
    basicAddressInfo.customFields = addressInfo
  }
  return basicAddressInfo
}